import { Link } from "react-router-dom";

export default function CompanyLogo({ company: company }: { company: any }) {
  const logoUrl = company?.logoUrl || undefined;
  return (
    <Link to={`/${company?.name}/${company?.companyId}`}>
      {logoUrl ? (
        <img
          src={logoUrl}
          alt={company?.name}
          className="w-32 md:w-40 max-h-12 hover:cursor-pointer object-contain object-left"
        />
      ) : (
        <h2 className="text-2xl font-medium">{company?.name}</h2>
      )}
    </Link>
  );
}
